import { render, staticRenderFns } from "./customerAllocation.vue?vue&type=template&id=3d459796&scoped=true&"
import script from "./customerAllocation.vue?vue&type=script&lang=js&"
export * from "./customerAllocation.vue?vue&type=script&lang=js&"
import style0 from "./customerAllocation.vue?vue&type=style&index=0&id=3d459796&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d459796",
  null
  
)

export default component.exports